import { request } from './request.js'

export const getOrders = params => request.get('orders', { params })
export const getOrdersSearch = params => request.get('orders/search', { params })
export const getOrdersById = id => request.get('orders/' + id)
export const createOrders = data => request.post('orders', data)
export const recordPaymentFlowEvent = data => request.post('orders/payment-flow-event', data)
export const validateOrders = data => request.post('orders/validate', data)
export const updateOrders = (id, data) => request.put('orders/' + id, data)
